import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import _ from 'lodash';

const converter = {
  toFirestore(group: UserManagement.Group): firebase.firestore.DocumentData {
    return group;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<UserManagement.Group>,
    options: firebase.firestore.SnapshotOptions,
  ): UserManagement.Group {
    const group = {
      ...snapshot.data(options),
    };

    return {
      ...group,
      userIds: _.uniq(group.userIds),
    };
  },
};

const getGroupsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.GROUPS_COLLECTION)
    .withConverter(converter);
};

export default getGroupsRef;
